import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "../../../../ui/dialog";
import { Button } from "../../../../ui/button";
import { cancelJobIfNoShovellerApplied, cancelJob } from "../../../../../apiManager/houseOwner/matchShvoller";
import { setCredentials } from "../../../../../slices/authSlice";
import { IoMdClose } from "react-icons/io";

export function CancelDialog({ job }) {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleCancelJob = async () => {
    try {
      setLoading(true);
      setError(null);
      
      let res;
      
      if (job.jobStatus === 'in-progress') {
        // For in-progress jobs, use cancelJob API with shovellerId
        const shovellerId = job.ShovelerInfo[0]?.ShovelerId?._id;
        if (!shovellerId) {
          setError('Shoveller information not found');
          return;
        }
        res = await cancelJob(job._id, shovellerId, "homeowner");
      } else {
        // For other job statuses, use the original API
        res = await cancelJobIfNoShovellerApplied(job._id);
      }
      
      if (res.err) {
        setError(res.err || 'An error occurred while canceling the job');
        return;
      }
  
      const userData = JSON.parse(localStorage.getItem('userInfo'));
      dispatch(setCredentials({
        user: {
          id: userData.user.id,
          role: userData.user.role,
        },
        token: userData.token,
      }));

      setOpen(false);
      // You might want to refresh the job data or navigate away here
      window.location.reload(); // or use a callback prop for parent to handle
    } catch (err) {
      setError('Failed to cancel job');
      console.error("Error cancelling job:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button 
        onClick={() => setOpen(true)}
        variant="outline"
      >
        Cancel Job
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Cancel Job</DialogTitle>
            <DialogDescription>
              {job.jobStatus === 'in-progress' 
                ? "Are you sure you want to cancel this ongoing job? This may affect your rating."
                : "Are you sure you want to cancel this job? This action cannot be undone."
              }
            </DialogDescription>
          </DialogHeader>
          
          {error && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-3">
              <p className="text-red-700 text-sm">{error}</p>
            </div>
          )}

          <DialogFooter>
            <Button 
              variant="outline" 
              onClick={() => setOpen(false)}
              disabled={loading}
            >
              Keep Job
            </Button>
            <Button 
              onClick={handleCancelJob}
              className="bg-red-600 hover:bg-red-700 text-white"
              disabled={loading}
            >
              {loading ? "Cancelling..." : "Yes, Cancel Job"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}